import './bootstrap'
import Vue from 'vue'
import SearchApp from "./SearchApp"

Vue.prototype.$works = window.works
Vue.config.productionTip = false

new Vue({
    el: '#search-vue-app',
    components: {
        SearchApp,
    }
})
